import React from "react";
import { Component } from "react";
import {
  View,
  Text,
  TextInput,
  TouchableOpacity,
  Platform,
  Image,
} from "react-native";
import { Picker } from "@react-native-picker/picker";
import styles from "../../styles/monthlyStyle";
import HocComponent from "../../commonComponents/Hoc";
import CustomDropDownV2 from "../../commonComponents/CustomDropdownV2";
import { renderers } from "react-native-popup-menu";
import arrowUp from "../../../assets/images/arrowforward.png";
import arrowDown from "../../../assets/images/arrowdown.png";
import { renderPaynowBtn } from "./functions";
const regexOnlyNumber = /^[0-9 ]*$/;

const regexOnlyText = /^[a-zA-Z. ]*$/;
const { NotAnimatedContextMenu } = renderers;
class InternetBanking extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedValue: "",
      disableSubmit: false,
      visibleDropDown: false,
      width: 0,
    };
  }
  // onchange TextInput
  textInputChange = (name, val, index, sectionName) => {
    const config = this.props.inputArray;

    switch (name) {
      case "Customer Name":
        try {
          for (var i = 0; i < config.length; i++) {
            if (config[i].name == name && regexOnlyText.test(val)) {
              config[i].value = val;
              config[i].correct = true;
            }
          }
        } catch (e) {}
        break;
      case "Bank Name":
        try {
          for (var i = 0; i < config.length; i++) {
            if (config[i].name == name) {
              config[i].value = val;
              config[i].correct = true;
              config[i].enableDefaultValue = false;
            }
          }
        } catch (e) {}
        break;

      case "Account Number":
        try {
          for (var i = 0; i < config.length; i++) {
            if (config[i].name == name && regexOnlyNumber.test(val)) {
              config[i].value = val
                .replace(/\s?/g, "")
                .replace(/(\d{4})/g, "$1 ")
                .trim();
              config[i].correct = true;
            }
          }
        } catch (e) {}
        break;

      case "Sort Code":
        try {
          for (var i = 0; i < config.length; i++) {
            if (config[i].name == name) {
              let newVal =
                val.length != 0
                  ? val.match(/\d{2}(?=\d{2})|\d+/g).join("-")
                  : "";
              config[i].value = newVal;
              config[i].correct = true;
            }
          }
        } catch (e) {}
    }
    this.setState({ inputArray: config });
  };

  onDropDownSelect(name, value, index) {
    this.setState({
      selectedValue: value,
    });
    this.textInputChange(name, value, index, "");
  }

  getHeader = () => {
    const { selectedValue, visibleDropDown } = this.state;
    const { inputArray } = this.props;
    const dropDownHeaderTextSTyleResponsive = `dropDownHeaderTextSTyleResponsive_${this.props.measure}`;
    return (
      <View
        style={[styles.headerStyle, { backgroundColor: "white" }]}
        onLayout={(event) =>
          this.setState({ width: event.nativeEvent.layout.width })
        }
      >
        <View style={{ flexDirection: "row" }}>
          <Text
            style={[
              styles.dropDownHeaderTextSTyle,
              styles[dropDownHeaderTextSTyleResponsive],
              { color: inputArray[1].value != "" ? "black" : "#a9a9a9" },
            ]}
          >
            {inputArray[1].value != "" ? inputArray[1].value : "Bank Name*"}
          </Text>
          <Image
            style={{ width: 20, height: 20 }}
            source={visibleDropDown ? arrowDown : arrowDown}
          ></Image>
        </View>
      </View>
    );
  };

  menuOptionComponent = (props) => {
    return (
      <View>
        <Text style={{ fontFamily: "SFProText", marginVertical: 3 }}>
          {props}
        </Text>
      </View>
    );
  };
  // TextInput UI render
  renderTextInputs = () => {
    const textInputRes = `textInputRes_${this.props.measure}`;
    const textInputView = `textInputView_${this.props.measure}`;
    const textInputErrorView = `textInputErrorView_${this.props.measure}`;

    return this.props.inputArray.map((item, index) => {
      if (item.type == "dropdown") {
        return (
          <View
            nativeID={`inputField_${index}`}
            style={
              Platform.OS !== "web"
                ? { width: "100%" }
                : [styles.textInputView, styles[textInputView]]
            }
          >
            {Platform.OS !== "web" ? (
              <View style={{ width: "100%", paddingBottom: 20 }}>
                <CustomDropDownV2
                  styleMenuOptions={{
                    width: this.state.width ? this.state.width : "100%",
                    marginTop: 48,
                  }}
                  menuOptionHeader={this.getHeader}
                  menuOptionComponent={this.menuOptionComponent}
                  menuOptionDataArray={this.props.inputArray[index].bankArray}
                  propRenderer={NotAnimatedContextMenu}
                  preferredPlacement="bottom"
                  onSelectionOption={(value) =>
                    this.onDropDownSelect(item.name, value, index, "")
                  }
                  onMenuOpen={() => this.setState({ visibleDropDown: true })}
                  onMenuClose={() => this.setState({ visibleDropDown: false })}
                />
                {item.correct == false && (
                  <View
                    style={[
                      styles.textInputErrorView,
                      styles[textInputErrorView],
                      { marginLeft: 15 },
                    ]}
                  >
                    <Text style={styles.textInputError}>{item.errorMsg}</Text>
                  </View>
                )}
              </View>
            ) : (
              <Picker
                selectedValue={item.value}
                onValueChange={(itemValue, index) =>
                  this.textInputChange(item.name, itemValue, index, "")
                }
                style={[
                  styles.textInput,
                  styles[textInputRes],
                  styles.backgroundWhite,
                  styles.borderWidth0,
                ]}
                mode="dropdown"
              >
                {item.enableDefaultValue && (
                  <Picker.Item
                    color="grey"
                    label="Please Select a Bank"
                    value="0"
                  />
                )}
                {item.bankArray.map((bankItem, indx) => {
                  return <Picker.Item label={bankItem} value={bankItem} />;
                })}
              </Picker>
            )}
            {item.correct == false && Platform.OS === "web" && (
              <View
                style={[
                  styles.textInputErrorView,
                  styles[textInputErrorView],
                  { zIndex: -1 },
                ]}
              >
                <Text style={styles.textInputError}>{item.errorMsg}</Text>
              </View>
            )}
          </View>
        );
      }
      return (
        <View
          nativeID={`inputField_${index}`}
          style={[styles.textInputView, styles[textInputView]]}
        >
          <TextInput
            keyboardType={item.keyboardType}
            style={[
              styles.textInput,
              styles[textInputRes],
              styles.backgroundWhite,
            ]}
            onChangeText={(e) => {
              this.textInputChange(
                item.name,
                e,
                index,
                this.props.inputArray[index].name
              );
            }}
            placeholder={item.placeholder}
            value={item.value}
            maxLength={item.maxLength}
          />
          {item.correct == false && (
            <View
              style={[styles.textInputErrorView, styles[textInputErrorView]]}
            >
              <Text style={styles.textInputError}>{item.errorMsg}</Text>
            </View>
          )}
        </View>
      );
    });
  };
  onSubmit = () => {
    this.setState({
      disableSubmit: true,
    });

    var config = this.props.inputArray;
    var error = true;
    let customerCare = true;
    let bankName = true;
    let accountName = true;
    let sortCode = true;
    for (var i = 0; i < this.props.inputArray.length; i++) {
      if (config[i].name === "Customer Name") {
        if (config[i].value !== "") {
          customerCare = false;
          error = false;
          config[i].correct = true;
        } else {
          customerCare = true;

          error = true;
          config[i].correct = false;
        }

        this.setState({ inputArray: config });
      } else if (config[i].name === "Bank Name") {
        if (config[i].value !== "") {
          bankName = false;
          error = false;
          config[i].correct = true;
        } else {
          bankName = true;

          error = true;
          config[i].correct = false;
        }
        this.setState({ inputArray: config });
      } else if (config[i].name === "Account Number") {
        if (config[i].value !== "" && config[i].value.length === 19) {
          accountName = false;
          error = false;
          config[i].correct = true;
        } else {
          accountName = true;
          error = true;
          config[i].correct = false;
        }
        this.setState({ inputArray: config });
      } else if (config[i].name === "Sort Code") {
        if (config[i].value !== "" && config[i].value.length === 8) {
          sortCode = false;
          error = false;
          config[i].correct = true;
        } else {
          sortCode = true;
          error = true;
          config[i].correct = false;
        }
        this.setState({ inputArray: config });
      }

      if (
        !error &&
        customerCare == false &&
        bankName == false &&
        accountName == false &&
        sortCode == false
      ) {
        let data = {
          configData: this.props.inputArray,
          debitCard: false,
          valid: true,
          internetBanking: true,
          accountNumber: config[2].value,
        };
        this.props.onPressButton(data);
      } else if (i === this.props.inputArray.length - 1) {
        this.setState({
          disableSubmit: false,
        });
      }
    }
    // submit validations here;
  };

  render() {
    return (
      <View>
        {this.renderTextInputs()}
        <View style={styles.paynowBtnView}>
          <TouchableOpacity
            disabled={this.state.disableSubmit}
            onPress={() => this.onSubmit()}
            style={styles.payBtn}
          >
            <Text style={styles.txtPayNow}>Submit</Text>
          </TouchableOpacity>
        </View>
        {/* {renderPaynowBtn(
          this.state.inputArray.name,
          this.state.inputArray,
          this.onPressButton
        )} */}
      </View>
    );
  }
}
export default HocComponent(InternetBanking);
